/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  UserFlagsModeratorControllerFindOneQueryResponse,
  UserFlagsModeratorControllerFindOnePathParams,
  UserFlagsModeratorControllerFindOne401,
} from '../types/UserFlagsModeratorControllerFindOne.ts';

function getUserFlagsModeratorFindOneUrl(id: UserFlagsModeratorControllerFindOnePathParams['id']) {
  const res = { method: 'GET', url: `/api/moderator/user-flags/${id}` as const };
  return res;
}

/**
 * {@link /api/moderator/user-flags/:id}
 */
export async function userFlagsModeratorFindOne(
  id: UserFlagsModeratorControllerFindOnePathParams['id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    UserFlagsModeratorControllerFindOneQueryResponse,
    ResponseErrorConfig<UserFlagsModeratorControllerFindOne401>,
    unknown
  >({ method: 'GET', url: getUserFlagsModeratorFindOneUrl(id).url.toString(), ...requestConfig });
  return res.data;
}
